import { render } from "./icon-two-bar.vue?vue&type=template&id=299af5b0"
const script = {}

import exportComponent from "D:\\project\\newD\\floor30-ws-with-server-selection\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__